import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { formatBoldText } from '../../utils/formatBoldText';
import { useAnalyticalVariableCardContext } from '../AnalyticalVariableCard/AnalyticalVariableCardContext';
import { sectionLabelSx } from '../analyticalVariableCard.constants';

export const AVSummaryCard = () => {
  const { analyticalVariable } = useAnalyticalVariableCardContext();
  const intl = useIntl();
  return (
    <Box data-testid="av-detail-description" sx={{ mb: 2 }}>
      <Typography variant="body1" sx={sectionLabelSx}>
        {intl.formatMessage({ id: 'projects.analyticalVariables.detailModal.description' })}
      </Typography>
      <Typography data-testid="av-detail-description-value" variant="body1">
        {formatBoldText(analyticalVariable.description ?? '')}
      </Typography>
    </Box>
  );
};
